import React, { useEffect, useMemo, useState } from 'react';
import T from 'i18n';
import { useSelector } from 'react-redux';
import { Modal } from 'features/common/MaterialBasedComponents';
import { Spinner } from 'features/common';
import { selectTakeReferencePending } from '../../redux/selectors';

const ModalTakeReference = ({ show, handleClose, handleSave, action, selectedRows }) => {
  const [loading, setLoading] = useState(false);
  const takeReferencePending = useSelector(selectTakeReferencePending);
  const hasSelection = Boolean(selectedRows && selectedRows.length);

  const onSave = () => {
    if (!hasSelection) return;
    setLoading(true);
    handleSave(null, action, selectedRows, null, () => {}, setLoading);
  };

  useEffect(() => {
    if (!takeReferencePending) {
      setLoading(false);
    }
  }, [takeReferencePending]);

  const body = useMemo(() => {
    if (!hasSelection) return T.translate('generic.noFilesSelected');
    if (loading || takeReferencePending) return <Spinner />;
    return T.translate('case.takeReferenceDescription');
  }, [hasSelection, loading, takeReferencePending]);

  return (
    <Modal
      show={show}
      title={T.translate('generic.takeReference')}
      handleClose={handleClose}
      handleSave={onSave}
      disableSave={loading || takeReferencePending || !hasSelection}
      saveTitle={T.translate('generic.takeReference')}
    >
      {body}
    </Modal>
  );
};

export default ModalTakeReference;
